import React, { useState, useRef } from "react";
// import ExifReader from "exifreader"; // get the exif orientation
import piexif from "piexifjs"; // stripe exif metadaa
import Resizer from "react-image-file-resizer"; // resize image
import noImage from "../data/images/no-image1.jpeg";
import { MdDeleteForever } from "react-icons/md";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { storage } from "../services/firebaseConfig";
import { getRandomString } from "../helpers/randomString";
import { useStateContext } from "../contexts/ContextProvider";

const ImageUploader = (props) => {
  const { stateObject, setStateObject, name } = props;
  const { user } = useStateContext();
  const [imageUploadError, setImageUploadError] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [tooManyFiles, setTooManyFiles] = useState(false);

  const maxUploads = 9;
  const maxFileSizeMB = 5;

  const fileInputRef = useRef(null);

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleImages = async (event) => {
    const newImagesObj = event.target.files;
    let safeArray = stateObject.images;
    let list = new DataTransfer();

    if (safeArray.length + newImagesObj.length > maxUploads) {
      setImageUploadError(true);
      setTooManyFiles(true);
      resetImageErrors();
      document.getElementById("images").value = "";
      return;
    }

    for (let i = 0; i < newImagesObj.length; i++) {
      if (newImagesObj[i].size <= maxFileSizeMB * 1024 * 1024) {
        // const tags = await ExifReader.load(newImagesObj[i]); // read metadata orientation
        // const rotation = getRotation(tags.Orientation.value);
        // console.log("Orient:", tags.Orientation.value);

        const resizedFile = await resizeFile(newImagesObj[i]);
        const strippedAndResizedFile = await removeExifData(resizedFile);

        // define storge location, and new file name
        const imageRef = ref(
          storage,
          `${name}/${user.uuid}/${getRandomString(20)}.${
            newImagesObj[i].name.split(".")[1]
          }`
        );

        const metadata = {
          contentType: newImagesObj[i].type,
          customMetadata: {
            [name]: stateObject.id,
            property: stateObject.propertyId,
          },
        };

        // upload file to cloud
        await uploadBytes(imageRef, strippedAndResizedFile, metadata).then(
          async (snapshot) => {
            await getDownloadURL(snapshot.ref).then((url) => {
              // collect url, and add to array
              safeArray.push(url);
            });
          }
        );

        let file = new File([newImagesObj[i].type], newImagesObj[i].name);
        list.items.add(file);
      } else {
        setErrorArray((prevState) => [...prevState, newImagesObj[i].name]);
        setImageUploadError(true);
        resetImageErrors();
        continue;
      }
    }
    document.getElementById("images").files = list.files;
    setStateObject((prevState) => ({ ...prevState, images: safeArray }));
  };

  // remove metadata
  const removeExifData = async (imageFile) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        const dataUrl = e.target.result;
        try {
          // stipes metadata from base64 image
          const strippedDataUrl = piexif.remove(dataUrl);

          // convert base64 back to blob
          const byteString = atob(strippedDataUrl.split(",")[1]);
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([ab], { type: "image/jpeg" });

          // return blob for upload
          resolve(blob);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = function (error) {
        reject(error);
      };
      reader.readAsDataURL(imageFile);
    });
  };

  // resize files
  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file, // The image file to be resized
        1020, // maxWidth of the resized image
        679, // maxHeight of the resized image
        "JPEG", // compressFormat (e.g., "JPEG", "PNG", "WEBP")
        80, // quality (0-100)
        0, // rotation
        (uri) => {
          resolve(uri); // Callback function returning the resized image URI (base64)
        },
        "file" // outputType (e.g., "base64", "blob", "file")
      );
    });

  // const getRotation = (orientationValue) => {
  //   // 3 & 4 -> rotate 180 degs
  //   // 5 & 6 -> rotate -90 degs (ccw)
  //   // 7 & 8 -> rotate 90 degs (cw)
  //   switch (orientationValue) {
  //     case 3:
  //       return 0;
  //     case 4:
  //       return 0;
  //     case 5:
  //       return 0;
  //     case 6:
  //       return 0;
  //     case 7:
  //       return 0;
  //     case 8:
  //       return 0;
  //     default:
  //       return 0;
  //   }
  // };

  const resetImageErrors = () => {
    setTimeout(() => {
      setImageUploadError(false);
      setTooManyFiles(false);
      setErrorArray([]);
    }, 5000);
    clearTimeout();
  };

  const removeImage = (index) => {
    // delete image from image server
    const imageRef = ref(storage, `${stateObject.images[index]}`);
    const isDeleted = deleteObject(imageRef)
      .then(() => {
        console.log("Image deleted successfully!");
        return true;
      })
      .catch((error) => {
        console.error("Error deleting image:", error);
        return false;
      });

    // remove image from state
    if (isDeleted) {
      setStateObject((prevState) => ({
        ...prevState,
        images: stateObject.images.toSpliced(index, 1),
      }));
      const oldFileList = Array.from(document.getElementById("images").files);
      let list = new DataTransfer();

      for (let i = 0; i < oldFileList.length; i++) {
        if (i === index) {
          continue;
        } else {
          let file = new File([oldFileList[i].type], oldFileList[i].name);
          list.items.add(file);
        }
      }
      document.getElementById("images").files = list.files;
    }
  };

  return (
    <>
      <div className="text-lg text-justified mt-5 px-14">Select Images</div>
      <div className="mb-5">(Max. {maxUploads})</div>
      {stateObject.images.length === 0 && (
        <img
          src={noImage}
          alt="Preview"
          className="h-24 w-24 object-cover"
          onClick={handleClick}
        />
      )}
      <div
        className={` ${
          stateObject.images.length < 3
            ? `flex justify-center gap-1`
            : " grid grid-cols-3 gap-1"
        }`}
      >
        {stateObject.images.map((item, index) => {
          return (
            <div key={index} className="relative">
              <img
                src={
                  item instanceof Blob
                    ? URL.createObjectURL(item)
                    : item || noImage
                  //remove this logic once image handling is setup
                }
                alt="Preview"
                className={`h-24 w-24 object-cover ${
                  index === 0 ? "border-snappily-orange border-4" : ""
                }
                `}
              />
              <MdDeleteForever
                className="absolute bottom-0 right-0 text-xl bg-gray-300 hover:bg-red-500"
                onClick={() => {
                  removeImage(index);
                }}
              />
            </div>
          );
        })}
      </div>
      <label className="grid">
        <input
          id="images"
          name="images"
          type="file"
          ref={fileInputRef}
          multiple
          accept="image/*"
          className="w-[185px] border-black border-1 mt-5"
          onChange={handleImages}
        />
      </label>
      {imageUploadError && errorArray.length > 0 && (
        <div className="text-center text-red-500 mt-2 px-20">
          {errorArray.length}
          {errorArray.length > 1 ? " Files were" : " File was"} too large.
        </div>
      )}
      {imageUploadError && tooManyFiles && (
        <div className="text-center text-red-500 mt-2 px-20">
          Too Many Files. The max is {maxUploads} images.
        </div>
      )}
    </>
  );
};

export default ImageUploader;
